import { DateRangeDropdownV2, FormFieldV2, SearchFieldV2 as SearchField } from '@/components/custom/erp';
import { accountSearchColumns } from '@/constants/search-columns';
import { Label } from '@/components/ui/label';
import { TaiKhoan } from '@/types/schemas';
import { QUERY_KEYS } from '@/constants';

interface BasicInfoProps {
  searchFieldStates: {
    account: TaiKhoan | null;
    setAccount: (account: TaiKhoan | null) => void;
  };
}

const BasicInfo: React.FC<BasicInfoProps> = ({ searchFieldStates }) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='flex flex-col space-y-3'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Ngày h.toán từ/đến:</Label>
          <div className='w-[450px]'>
            <DateRangeDropdownV2 fromDateName='ngay_h_toan_tu' toDateName='ngay_h_toan_den' />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Được thanh toán đến:</Label>
          <FormFieldV2 name='duoc_thanh_toan_de' type='date' />
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Ngày tất toán:</Label>
          <FormFieldV2 name='ngay_tat_toan' type='date' />
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Tài khoản nợ:</Label>
          <SearchField<TaiKhoan>
            type='text'
            columnDisplay={'code'}
            displayRelatedField={'name'}
            searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
            searchColumns={accountSearchColumns}
            value={searchFieldStates.account?.code || ''}
            relatedFieldValue={searchFieldStates.account?.name || ''}
            onRowSelection={searchFieldStates.setAccount}
          />
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
